<template>
	<v-btn icon small @click.stop="showInfo"><v-icon>far fa-circle-question</v-icon></v-btn>
</template>

<script>
export default {
	data: () => ({}),
	props: {
		title: {
			type: String,
			default: null,
		},
		message: {
			type: String,
			default: null,
		},
	},
	methods: {
		showInfo() {
			this.$store.commit("showDialog", {
				type: "info",
				title: this.title,
				message: "<p>" + this.message + "</p>",
			});
		},
	},
};
</script>
